import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { NgxPageScrollCoreModule } from '../../directives/ngx-page-scroll/ngx-page-scroll-core/ngx-page-scroll-core.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 0.5,
};


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    VirtualScrollerModule,
    NgxPageScrollCoreModule,
  ],
  exports: [
    PerfectScrollbarModule,
    VirtualScrollerModule,
    NgxPageScrollCoreModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
  ]
})
export class SmashScrollbarModule { }
